export default {
  CREATE: {
    TITLE: `Créer une requête de disponibilité`,
    SUMMARY: `Partagez vos disponibilités afin d'avoir un horaire optimal.`
  },
  EDIT: {
    TITLE: `Modifier une requête de disponibilité`,
    SUMMARY: `Modifiez une requête de disponibilité partagée précédemment.`
  },
  VIEW: {
    TITLE: `Voir une requête de disponibilité`,
    SUMMARY: `Affichez une requête de disponibilité partagée précédemment.`
  },
  DATEVALID: {
    LABEL: `Date de début`,
    PLACEHOLDER: ``,
    DESCRIPTION: `La date de début doit être postérieure au {{minimumDate}} et ne peut pas être la même date qu'une autre disponibilité.`,
    TEMPORARY_DESCRIPTION: `Cette date ne doit pas être dans le passé.`
  },
  DATEEXPIRED: {
    LABEL: `Date de fin`,
    PLACEHOLDER: ``,
    DESCRIPTION: `Cette date ne doit pas être dans le passé et doit se trouver au moins une semaine après la date de début.`
  },
  NOTES: {
    LABEL: `Notes`,
    PLACEHOLDER: ``,
    DESCRIPTION: `Entrez des notes ou des informations supplémentaires, elles seront visibles uniquement par votre gestionnaire.`
  },
  TEMPORARY: {
    LABEL: `Fixer une date de fin`,
    DESCRIPTION: ``
  },
  REGULAR: {
    LABEL: `Se répète indéfiniment`,
    DESCRIPTION: `Cette disponibilité sera valide jusqu'au début de la prochaine disponibilité`
  },
  COPY_MODAL: {
    TITLE: `Copier/Coller une journée`,
    PRIMARY_ACTION: `Appliquer`,
    SUMMARY: ``
  },
  AVAILABILITYSTART: {
    LABEL: ``,
    DESCRIPTION: ``,
    PLACEHOLDER: ``
  },
  AVAILABILITYEND: {
    LABEL: ``,
    DESCRIPTION: ``,
    PLACEHOLDER: ``
  },
  UNMATCHED_AVAILABILITIES_WARNING: `Les disponibilités suivantes ne peuvent pas être modifiées, veuillez contacter votre gestionnaire pour les changer.`,
  ADD_RANGE: `Spécifier une plage`,
  ADD_ANOTHER_RANGE: `Ajouter une autre plage`,
  SET_AVAILABLE: `Indiquer comme disponible`,
  SET_UNAVAILABLE: `Indiquer comme indisponible`,
  SET_PREFERRED: `Indiquer comme préférence`,
  NOTAVAILABLE: { OPTIONS: { true: { LABEL: `Non disponible`, DESCRIPTION: `` }, false: { LABEL: `Disponible`, DESCRIPTION: `` } } },
  NOTES_REQUIRED: `Un commentaire est requis.`,
  START_DATE_AFTER_TODAY: `La date de début doit être après celle d'aujourd'hui.`,
  START_DATE_CUTOFF_ERROR: `La date de début doit être postérieure au {{minimumDate}}.`,
  START_DATE_UNIQUE: `La date de début ne doit pas être la même que celle d'une autre disponibilité.`,
  START_DATE_REQUIRED: `Une date de début est requise.`,
  END_DATE_REQUIRED: `Une date de fin est requise.`,
  END_DATE_AFTER_START: `La date de fin doit être au moins une semaine après la date de début.`,
  AVAILABLE_ALL_DAY: `Disponible`,
  UNAVAILABLE_ALL_DAY: `Indisponible`,
  UNAVAILABLE: `Indisponible`,
  AVAILABLE: `Disponible`,
  PREFERRED: `Préfère`,
  APPROVAL_REQUIRED_MESSAGE: `Votre gestionnaire doit approuver les modifications apportées aux disponibilités avant qu'elles soient actives.`,
  CHANGES_REQUESTED_MESSAGE: `Votre gestionnaire vous demande de modifier ces disponibilités avant qu'elles ne deviennent actives.`,
  NOTE_FROM_MANAGER: `Note de votre gestionnaire :`,
  NONE: `Aucun`,
  COPY_TO_FOLLOWING: `Votre disponibilité pour {{ day }} sera appliquée pour les jours suivants :`
}
